import { Component, OnInit, ErrorHandler } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { UserService } from '../../../shared/user.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-agent-transfer-form',
  templateUrl: './agent-transfer-form.component.html',
  styleUrls: ['./agent-transfer-form.component.css']
})
export class AgentTransferFormComponent implements OnInit {

  title = "Agent Transfer";
  cc: any = {};
  data: any = {};
  formInvalid: boolean = false;
  p: any = {};
  a: any = {};
  aa: any = {};
  ab: any = {};
  ac: any = {};
  AGENT_ID: number;
  ACC_ID: number;
  CUSTID: number;
  mode: string;
  AccNolist: any = {}
  AgentList: any = {}
  AgenSectList: any = {}
  Custlist: any;
  AgentAccountDetailsList: any;
  AgentNamelist: any = {}
  fileToUpload: File = null;
  hide: boolean = false;
  numericpattern = "^[0-9]*$";
  alphabetpattern = "^[a-zA-Z ]*$";
  alphanumpattern = "^[a-zA-Z0-9 ]*$";
  emailpattern = "^[a-zA-Z0-9._%-+]+@[a-z0-9.-]+\.[a-z]{2,3}$";
  agepattern = "[1-100]";
  Accountnum = "/^([0-9]{11})|([0-9]{2}-[0-9]{3}-[0-9]{6})$/";
  today: Date;
  flag: any = null;

  constructor(private Service: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler,
  ) { }
  ngOnInit() {
    debugger

    this.GetAllData();

    // this.route.params.subscribe(params => {
    //   debugger;
    //   this.AGENT_ID = params['AGENT_ID'];
    //   this.mode = params['mode'];

    //   // if (this.AGENT_ID > 0) {
    //   //   this.GetPigmyById(this.AGENT_ID)
    //   }
    //   if (this.mode == 'View') {
    //     this.hide = true;

    //   }
    // });

    // if (this.mode == 'View') {
    //   this.title = "View Pigmy ";
    // }
    // else if (this.mode == 'edit') {
    //   this.title = "Edit Pigmy";
    // }


  }
  GetAllData() {

    //ddl for branch  
    this.data = this.Service.GetAllAgent();
    this.data.subscribe(
      (response: any) => {
        this.AgentList = response;
      })



    this.data = this.Service.GetAllAgent2();
    this.data.subscribe(
      (response: any) => {
        this.AgenSectList = response;
      })

  }



  //update 
  UpdateAgent(Agent: NgForm) {
    debugger;
    var AgentDetails=[];
    for (let i = 0; i < this.AgentAccountDetailsList.length; i++) {
      if (this.AgentAccountDetailsList[i].selected == true) {
        let temp={
          NAME:this.AgentAccountDetailsList[i].NAME,
          ACC_ID:this.AgentAccountDetailsList[i].ACC_ID,
          ACC_NO:this.AgentAccountDetailsList[i].ACC_NO,
          TRANS_AMT:this.AgentAccountDetailsList[i].TRANS_AMT
        }
        AgentDetails.push(temp);
      }
    }

    Agent.value.CusDetailsModel = AgentDetails;
    this.data = this.Service.UpdateAgent(this.a.AGENT_ID,Agent.value);
    this.data.subscribe(
      (response) => {
        swal('Success!', ' Agent Transfered successfully.', 'success');
        Agent.reset();
        Agent.resetForm();
        Agent.form.markAsPristine();
        Agent.form.markAsUntouched();
        this.AgentAccountDetailsList=[];
        // this.router.navigate(['/home/complaint/']) ;         
      }, 
      
      (error) => {

        if (error.status == 401 || error.status == 500) {
          this.errorHandler.handleError(error);
        }
        else if (error.status == 400) {

        }
      });
  }


  GetAgentAccDetailsById(AGENT_ID) {

    this.data = this.Service.GetAgentAccDetailsById(AGENT_ID);
    this.data.subscribe(
      (response: any) => {
        this.AgentAccountDetailsList = response
        for (let i = 0; i < this.AgentAccountDetailsList.length; i++) {
              this.AgentAccountDetailsList[i].selected = false;
        }
      }, (error) => {

        if (error.status == 401 || error.status == 500) {
          this.errorHandler.handleError(error);
        }
        
      });
  }
  name: any;
  selectedAll: any;
  NAME: any

  // selectAll() {
  //   for (var i = 0; i < this.NAME.length; i++) {
  //     this.NAME[i].NAME = this.selectedAll;
  //   }
  selectAll() {
    if (this.flag == 0 || this.flag == null) {
      this.flag = 1;
    } else { this.flag = 0; }
    for (var i = 0; i < this.AgentAccountDetailsList.length; i++) {
      if (this.flag == 1) {
        this.AgentAccountDetailsList[i].selected = true;
      }
      else {
        this.AgentAccountDetailsList[i].selected = false;
      }
    }
  }

  changeCheckbox(ACC_NO) {
    for (let i = 0; i < this.AgentAccountDetailsList.length; i++) {
      if (this.AgentAccountDetailsList[i].ACC_NO == ACC_NO) {
        if (this.AgentAccountDetailsList[i].selected == false) {
          this.AgentAccountDetailsList[i].selected = true;
          break;
        }
        else { this.AgentAccountDetailsList[i].selected = false; }
        break;
      }
    }
  }


  Cancel()
  {
    this.ac.AGENT_ID='';
    this.a.AGENT_ID='';
    this.AgentAccountDetailsList=[];
  }







}







// WEBPACK FOOTER //
// ./src/app/general-transaction/agent-transfer/agent-transfer-form/agent-transfer-form.component.ts